
function getSession() {
    const token = JSON.parse(sessionStorage.getItem("token"));
    const cbid = JSON.parse(sessionStorage.getItem("cbid"));
    return { token, cbid };
}

export async function getUser() {
    const browserData = getSession();

    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${browserData.token}` }
    };
    const response = await fetch(`${process.env.REACT_APP_HOST}600/users/${browserData.cbid}`, requestOptions)

    if (!response.ok) {
        const errorMessage = { message: response.statusText, status: response.status };
        sessionStorage.clear();
        throw errorMessage;
    }

    const data = await response.json();

    return data;
}

export async function getUserOrders() {
    const browserData = getSession();

    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${browserData.token}` }
    }

    const response = await fetch(`${process.env.REACT_APP_HOST}660/orders?user.id=${browserData.cbid}`, requestOptions);

    if (!response.ok) {
        const errorMessage = { message: response.statusText, status: response.status };
        throw errorMessage;
    }

    const data = await response.json();

    return data;
}

export async function createOrder(cartList, total, user) {
    const browserData = getSession();
    const date = new Date();

    const order = {
        cartList: cartList,
        amount_paid: total,
        quantity: cartList.length,
        time: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`,
        user: {
            name: user.name,
            email: user.email,
            id: user.id
        }
    }

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${browserData.token}` },
        body: JSON.stringify(order)
    }

    const response = await fetch(`${process.env.REACT_APP_HOST}660/orders`, requestOptions);

    if (!response.ok) {
        const errorMessage = { message: response.statusText, status: response.status };
        throw errorMessage;
    }

    const data = await response.json();

    return data;
} 